import usePersistence from './usePersistence';

const useAppPersistence = ({
    isRestoring,
    characters,
    setSelectedCharacter,
    allCards,
    setSelectedCard,
    setSelectedStars,
    setEditableStats,
    setAptitudes,
    setActiveSkills,
    skillsRestored,
    setUniqueSkillLevel,
    setPotentialLevel,
    setIsLimiterActive,
    setLimiterBudget,
    selectedCharacter,
    selectedCard,
    selectedStars,
    editableStats,
    aptitudes,
    activeSkills,
    uniqueSkillLevel,
    potentialLevel,
    isLimiterActive,
    limiterBudget,
    loading,
    setSupportDeck, // NEW
    supportDeck     // NEW
}) => {
    // Persistence Logic
    const restoreState = (saved) => {
        isRestoring.current = true;

        if (saved.characterId) {
            const char = characters.find(c => c.Id_Personaje === saved.characterId);
            if (char) setSelectedCharacter(char);
        }
        if (saved.cardId) {
            const card = allCards.find(c => c.card_id === saved.cardId);
            if (card) setSelectedCard(card);
        }
        if (saved.stars) setSelectedStars(saved.stars);
        if (saved.stats) setEditableStats(saved.stats);
        if (saved.aptitudes) setAptitudes(saved.aptitudes);

        if (saved.skills && saved.skills.length > 0) {
            setActiveSkills(saved.skills);
            skillsRestored.current = true; // Mark that we successfully restored skills
        }

        if (saved.uniqueLevel) setUniqueSkillLevel(saved.uniqueLevel);
        if (saved.potential) setPotentialLevel(saved.potential);
        if (saved.isLimiterActive !== undefined) setIsLimiterActive(saved.isLimiterActive);
        if (saved.limiterBudget !== undefined) setLimiterBudget(saved.limiterBudget);

        // Restore Support Deck
        if (saved.supportDeck) {
            setSupportDeck(saved.supportDeck);
        }

        // Clear restoring flag after a safety delay (to allow async fetches to complete)
        setTimeout(() => {
            isRestoring.current = false;
            skillsRestored.current = false; // Reset skill restoration flag
        }, 1000);
    };

    const { resetConfig } = usePersistence({
        key: 'uma_musume_config_v1',
        state: {
            characterId: selectedCharacter?.Id_Personaje,
            cardId: selectedCard?.card_id,
            stars: selectedStars,
            stats: editableStats,
            aptitudes,
            skills: activeSkills,
            uniqueLevel: uniqueSkillLevel,
            potential: potentialLevel,
            isLimiterActive,
            limiterBudget,
            supportDeck // NEW
        },
        onLoad: restoreState,
        canLoad: !loading && characters.length > 0 && allCards.length > 0
    });

    return { resetConfig, restoreState };
};

export default useAppPersistence;
// Revisado: 2025-12-16
